import React from "react";
import styled from "styled-components";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Lightroom from "react-lightbox-gallery";
// Assets

import slider1 from "../../assets/img/sliders/a1.jpg";
import slider2 from "../../assets/img/sliders/a2.jpg";
import slider3 from "../../assets/img/sliders/a3.jpg";
import slider4 from "../../assets/img/sliders/a4.jpg";
import slider5 from "../../assets/img/sliders/a5.jpg";
import slider6 from "../../assets/img/sliders/a6.jpg";
import slider7 from "../../assets/img/sliders/a7.jpg";
import g1 from "../../assets/img/sliders/g1.jpg";
import g2 from "../../assets/img/sliders/g2.jpg";
import g3 from "../../assets/img/sliders/g3.jpg";
import g4 from "../../assets/img/sliders/g7.jpg";
import g5 from "../../assets/img/sliders/g8.jpg";
import g6 from "../../assets/img/sliders/g9.jpg";
import g7 from "../../assets/img/sliders/g10.jpg";
import g8 from "../../assets/img/sliders/g11.jpg";

export default function Header() {
  var images = [
    {
      src: g1,
      desc: "Photo 1",
    },
    {
      src: g2,
      desc: "Photo 2",
    },
    {
      src: g3,
      desc: "Photo 3",
    },
    {
      src: g4,
      desc: "Photo 4",
    },
    {
      src: g5,
      desc: "Photo 5",
    },
    {
      src: g6,
      desc: "Photo 6",
    },
    {
      src: g7,
      desc: "Photo 7",
    },
    {
      src: g8,
      desc: "Photo 8",
    },
  ];
  var settings = {
    columnCount: {
      default: 4,
      mobile: 2,
      tab: 3,
    },
    mode: "dark",
  };
  return (
    <Wrapper id="home">
      <Carousel className="fade" autoPlay showThumbs={false} fade={true}>
        <div>
          <img alt="slider1" src={slider1} />
          <p className="legend">Smart & Connected Health Eco solution</p>
        </div>
        <div>
          <img alt="slider2" src={slider2} />
          <p className="legend">
            Documents & Product Package Anti-counterfeiting & Verification
            Eco-solution
          </p>
        </div>
        <div>
          <img alt="slider3" src={slider3} />
          <p className="legend">
            Comprehensive Health Program for Corporate Employees
          </p>
        </div>
        <div>
          <img alt="slider4" src={slider4} />
          <p className="legend">
            Comprehensive Health Program for School Students
          </p>
        </div>
        <div>
          <img alt="slider5" src={slider5} />
          <p className="legend">Connecting Cars Eco-solution</p>
        </div>
        <div>
          <img alt="slider6" src={slider6} />
          <p className="legend">Health Care Turnkey Provider</p>
        </div>
        <div>
          <img alt="slider7" src={slider7} />
          <p className="legend">e-Commerce Retail</p>
        </div>
      </Carousel>
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container flexSpaceCenter">
          <div>
            <h1 className="extraBold font60 text-center mb-20">At a Glance</h1>
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <p>
                  We are a group of next generation technology & program
                  management companies delivering solutions and services built
                  around intellectual property. We as a consolidated group has
                  created niche and ability to provide and distribute value
                  across industry using innovative technologies and program
                  management in various Industry Verticals thus delivering state
                  of the art domain based eco-solutions. Our eco-solutions
                  provide corporate, businesses and government a Turnkey
                  Solution Provider approach by securing data privacy and state
                  of the art technology and non-technology platforms on various
                  connected objects, onsite and on cloud and in between business
                  functionalities.
                </p>
                <p>
                  We specialized in our Turnkey Provider approach specially in
                  Health Care sector keeping in mind that the hospitals and
                  health care provider get the highest possible ROI from
                  healthcare infrastructure investments. As a turnkey provider
                  in health care sector our objective is to provide business
                  value.
                </p>
                <br />
                <h3 className="mb-20">Photo Gallery</h3>

                <Lightroom images={images} settings={settings} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
